import { giphyLightGrey } from '@giphy/colors'
import { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../manager'
import { CreationToolSourceFile } from '../../types'
import CreationToolOutputType from '../../types/output-type'
import Trimmer from '../trimmer'
import { Subtitle, TextSmall } from '../typography'

const Container = styled.div`
    padding: 15px 0;
`

const Header = styled.div`
    color: ${giphyLightGrey};
    display: flex;
    margin-bottom: 12px;
    width: 100%;

    ${Subtitle} {
        margin-bottom: 0;
        margin-right: auto;
    }

    ${TextSmall} {
        margin-bottom: 0;
    }
`

type Props = {
    source: CreationToolSourceFile
    playheadTime: number
    invalidDuration: boolean
    onTimeUpdate: (start: number, end: number, trimmed: boolean) => void
}

const CreationToolsVideoTrimTrimmer = ({ source, playheadTime, invalidDuration, onTimeUpdate }: Props) => {
    const { outputType } = useContext(CreationToolsContext)
    const title = CreationToolOutputType.title(outputType)
    const maxDuration = CreationToolOutputType.maxDuration(outputType)
    return (
        <Container>
            <Header>
                <Subtitle>
                    <i className="ss-video" />
                    Timeline
                </Subtitle>
                <TextSmall>
                    Max length for {title}s is {maxDuration}s
                </TextSmall>
            </Header>
            <Trimmer
                {...{
                    source,
                    playheadTime,
                    showInputs: true,
                    isInvalid: invalidDuration,
                    onUpdate: onTimeUpdate,
                }}
            />
        </Container>
    )
}

export default CreationToolsVideoTrimTrimmer
